import { render } from "./NewProject.vue?vue&type=template&id=e173fb7c&scoped=true"
import script from "./NewProject.vue?vue&type=script&lang=js"
export * from "./NewProject.vue?vue&type=script&lang=js"

import "./NewProject.vue?vue&type=style&index=0&id=e173fb7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e173fb7c"

export default script